import { useQuery } from '@tanstack/react-query';
import { getConditionGroups } from 'config/requests/gatewayRules';
import { ConditionGroup } from 'types/embedded/gatewayRule';

type UseConditionGroupsReturnValues = {
  conditionGroup: ConditionGroup | null;
  isLoadingConditionGroup: boolean;
  refetchConditionGroup: () => any;
};

export function useConditionGroups(id?: string): UseConditionGroupsReturnValues {
  const {
    data: conditionGroup = null,
    isLoading: isLoadingConditionGroup,
    refetch: refetchConditionGroup,
  } = useQuery({
    queryKey: ['condition_groups', id],
    queryFn: () => (id ? getConditionGroups(id) : null),
    enabled: typeof id !== 'undefined' && id !== '' && id !== null,
    gcTime: 0,
  });

  return { conditionGroup, isLoadingConditionGroup, refetchConditionGroup };
}
